import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomTooltip = (props) => {
  return (
    <OverlayTrigger
      placement={props?.placement || "auto"}
      overlay={
        <Tooltip id="tooltip-top">
          {props.dangerouslySetInnerHTML ? (
            <span dangerouslySetInnerHTML={{ __html: props.tooltip }}></span>
          ) : (
            <span>{props.tooltip}</span>
          )}
        </Tooltip>
      }
    >
      <span>{props.children}</span>
    </OverlayTrigger>
  );
};

export default CustomTooltip;
